import React from 'react';
import { Typography } from '@mui/material';

export const InitialCreationRender = () => <Typography>Product created</Typography>;
